<template>
    <DefaultHeader />

    <div v-if="missions?.length > 0" class="container">

        <div class="row d-flex justify-content-center">
            <div class="col-12">
                <div class="card shadow-sm mt-2 my-md-0 p-3 bg-history-list rounded history-list-shell">

                    <div class="row d-flex justify-content-between align-items-center">
                        <h5 class="text-center my-3">Historique des missions : </h5>
                    </div>

                    <div class="row d-flex justify-content-around align-items-center">
                        <div class="col-md-4">
                            <div class="input-group my-1">
                                <span class="input-group-text bg-secondary-subtle">Début : </span>
                                <input class="form-control" type="date" v-model="startDate" required>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group my-1">
                                <span class="input-group-text bg-secondary-subtle">Fin : </span>
                                <input class="form-control" type="date" v-model="endDate" required>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <ButtonDisplay class="col-2" :type="'search'" @click="onSearch" />
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div class="row d-flex justify-content-center">
            <div class="col-12 d-flex flex-column justify-content-between">
                <div class="card shadow mt-2 my-md-0 p-3 bg-white rounded">
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                    <OldMissions :missions="missions" />
                    <div class="d-flex justify-content-center my-2">
                        <div class="row col-12 col-md-6">
                            <div class="d-flex justify-content-start">
                                <div class="col-8"><label for="resPerPage">Résultats par page :</label></div>
                                <div class="col-3"><select name="resPerPage" id="resPerPage" class="form-select"
                                        v-model="perPage" @change="setPerPage($event)">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </select></div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-12">
                <div class="card shadow my-2 p-1 bg-white rounded">

                    <div class="row d-flex justify-content-between align-items-center">
                        <h5 class="text-center my-3">Aucun historique disponible</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import Pagination from '@/components/PaginationComponent.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import OldMissions from './Sections/OldMissions.vue'
import MissionRepository from '@/repositories/mission.repo.js'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        Pagination,
        ButtonDisplay,
        OldMissions
    },
    data() {
        return {
            missions: [],
            currentPage: 1,
            perPage: 15,
            startDate: null,
            endDate: null,
            count: 0,
            totalPages: 0
        }
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            MissionRepository.getFinished({
                page: this.currentPage,
                perPage: this.perPage,
                startDate: this.startDate,
                endDate: this.endDate
            })
                .then(result => {
                    this.missions = result.rows;
                    this.count = result.count;
                    this.totalPages = result.totalPages;
                    this.currentPage = result.page;
                    this.perPage = result.perPage;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        onSearch() {
            this.currentPage = 1;
            this.refreshData();
        },
        onPageChange(page) {
            this.currentPage = page
            this.refreshData();
        },
        setPerPage(event) {
            this.perPage = Number(event.target.value)
            this.currentPage = 1
            this.refreshData();
        },
    }
}
</script>

<style scoped>
.bg-history-list {
    background: #f8fafc !important;
}

.history-list-shell {
    border: 1px solid #e2e8f0;
}
</style>